import { fromNumber } from './u64';
import { fromString } from './string';
export { toNumber, ZERO } from './u64';
export { and, or, xor, shiftLeft, shiftRight, rotateLeft, rotateRight, } from './bitwise';
export { equals, greaterThan, lessThan } from './comparison';
export { add, subtract, multiply, divide, remainder, negate, } from './arithmetic';
export { toString } from './string';
export function from(value, radix = 10) {
    if (typeof value === 'number') {
        return fromNumber(value);
    }
    else {
        return fromString(value, radix);
    }
}
//# sourceMappingURL=index.js.map